export default __webpack_public_path__ + "static/media/ouro.4f15470e.svg";